<template>
<div>
    <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_advertis">
                <img src="@/assets/icon-restaurant-ads.png">
            </div>
            <h2 class="title_advertis">โฆษณา</h2>
        </div>
        <v-btn class="grad-primary-bg size_title_advertis white--text" height="50" width="20%" @click="$router.push('/restaurant')">
            ย้อนกลับ
        </v-btn>
    </div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show === true">เปลี่ยนสถานะเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เปลี่ยนรูปภาพเรียบร้อย</v-alert>

    </v-slide-x-reverse-transition>
    <MenuAdvertise />
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="mb-2 d-flex justify-space-between">
            <h3>ไม่บุฟเฟ่ต์</h3>
            <div class="d-flex">
                <div class="mr-2">สถานะ</div>
                <v-switch color="success" v-model="status_image" @click="changeStatus()" class="ma-0"></v-switch>
            </div>
        </div>

        <div class="d-flex justify-space-between card_advertise">
            <div class="mr-1">
                <v-form ref="form" @submit.prevent="addAdvertise()">
                    <v-file-input prepend-icon="mdi-file-upload-outline" accept="image/*" hide-details="auto" v-model="picture" label="เปลี่ยนรูปภาพโมษณา" @change="onFileChange"></v-file-input>
                    <div class="error--text text-center my-2">
                        ** ขนาดแนะนำ : 1200 x 1200 px **
                    </div>
                    <v-btn color="#28ab28" class="titlefont_advertise white--text" width="100%" height="50" type="submit">
                        บันทึก
                    </v-btn>
                </v-form>
            </div>
            <div class="ml-1 d-flex justify-center">
                <v-card width="50%">
                    <div class="d-flex justify-center align-center">
                        <v-img height="100%" max-width="100%" v-if="imagePreviewURL" :src="imagePreviewURL"></v-img>
                    </div>
                </v-card>
            </div>
        </div>

    </div>
</div>
</template>

<script src="@/previewimage.js"></script><script>
import {
    HTTP
} from "@/axios.js"
import MenuAdvertise from '@/components/menuadmin/MenuAdvertise.vue'
import before_image from "@/assets/icon-restaurant-ads.png";
export default {
    name: 'advertiseSingleDishMeal',
    components: {
        MenuAdvertise
    },
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show: false,
            picture_id: null,
            imagePreviewURL: before_image,
            picture: null,
            status_image: true,
            alert_show_add: false,
        }
    },
    methods: {
        async onFileChange(payload) {
            const file = payload
            if (file) {
                this.imagePreviewURL = URL.createObjectURL(file)
                URL.revokeObjectURL(file)
            } else {
                this.imagePreviewURL = before_image
            }
        },
        async advertiseDetail() {
            this.loading_page = true
            HTTP.get('/advertiseall', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.picture_id = response.data.detail[1].id
                        this.imagePreviewURL = response.data.detail[1].picture
                        this.status_image = response.data.detail[1].status == 1 ? true : false
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async changeStatus() {
            HTTP.post('/advertiseupdate/' + this.picture_id, {
                    status: this.status_image
                }, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.loading_page = false
                        this.alert_show = true
                        setTimeout(() => this.alert_show = false, 5000)
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async addAdvertise() {
            if (this.$refs.form.validate()) {
                this.loading_page = true
                let data = new FormData()
                let status = 0
                if (this.status_image) {
                    status = 1
                }
                data.append('picture', this.picture)
                data.append('status', status)

                HTTP.post('/advertiseupdate/' + this.picture_id, data, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.loading_page = false
                            this.alert_show_add = true
                            setTimeout(() => this.alert_show_add = false, 5000)
                        }

                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })

            }
        }
    },
    mounted() {
        this.advertiseDetail()
    }
}
</script>
